/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import {useContext} from "react";
import {usuarioContext} from "../../../App";
import Formulario_Deposito_Crear from "../../Formularios/Depositos/Formulario_Deposito_Crear";
import {crearDeposito} from "../../../CodNegocio/Depositos/crearDeposito";
import {envioNotificacionWass} from "../../../CodNegocio/Notificaciones/envioNotificacionWass";
import {NUMEROWASS} from "../../../Constantes";
import {formatoMonedaTabla} from "../../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";

const Dialogo_Deposito_Crear = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()

        let usuario = {
            id: entidad.idUsuario,
            nombre: entidad.nombre,
            codigo: entidad.codigoUsuario,
            correo: entidad.correo,
        }

        await crearDeposito({
            entidad: entidad,
            iniciarCarga: iniciarCarga,
            nuevoAviso: nuevoAviso,
            terminar: terminar,
            usuario: usuario
        })

        envioNotificacionWass({
            numero: NUMEROWASS,
            mensaje: `Nuevo deposito desde Administrador \n${cData.usuario.correo} \n${formatoMonedaTabla(entidad.valor)} \n${entidad.tipo}`
        })


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito_Crear props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => enviarDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Deposito_Crear